import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import zendeskComponent from './zendesk.component';

let zendeskModule = angular.module('zendesk', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
  .state('zendesk', {
    parent: 'standardLayout',
    url: '/support/tickets',
    component: 'zendesk',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    }
  });
})
.component('zendesk', zendeskComponent)
.name;

export default zendeskModule;


// WEBPACK FOOTER //
// ./client/app/pages/zendesk/zendesk.js